import { IconX } from '@tabler/icons-react'
import stringify from 'fast-safe-stringify'
import { useState } from 'react'

import { AstraCallout, day, getNow, isBefore, subtract } from '~/astra'
import { Maintenance } from '~/hooks/tanstack-query/betterstack/utils'

import { BannerText } from '../BannerText'
import { getDismissed, getPhase, LOCAL_STORAGE_KEY } from './utils'

const MaintenanceBannerContent = ({ reportId, latestUpdateId, title, latestUpdateMessage, latestUpdateTimestamp, startsAt, endsAt }: Maintenance) => {
    const [dismissed, setDismissed] = useState(() => getDismissed({ reportId, latestUpdateId, startsAt }))

    if (dismissed) return null

    const hideBanner = () => {
        localStorage.setItem(LOCAL_STORAGE_KEY, stringify({ reportId, latestUpdateId, phase: getPhase(startsAt) }))
        setDismissed(true)
    }

    return (
        <AstraCallout
            color="info"
            text={
                <BannerText
                    title={title}
                    latestUpdateMessage={latestUpdateMessage}
                    latestUpdateTimestamp={latestUpdateTimestamp}
                    startsAt={startsAt}
                    endsAt={endsAt}
                />
            }
            action={{ icon: <IconX />, onClick: hideBanner }}
            data-test="maintenance-banner"
        />
    )
}

export const MaintenanceBanner = (props: Maintenance) => {
    const { reportId, latestUpdateId, startsAt } = props
    const showFrom = subtract(day(startsAt), 5, 'days')

    if (isBefore(getNow(), showFrom)) return null

    // The `key` is used to reset the dismissed state when the maintenance changes (new report, new update, or phase transition)
    return <MaintenanceBannerContent key={`${reportId}-${latestUpdateId ?? 'none'}-${getPhase(startsAt)}`} {...props} />
}
